module.exports = __webpack_public_path__ + "static/media/footer_btn_menu.3181d1f2.svg";